import { normalizeForCompare } from '../../../utils/textNormalization';

/**
 * @param {Array<{ name?: string, text?: string, limitedTo?: number | null }>} parallelData
 * @param {{ cardParallelName?: string, cardSupply?: number | null, cardPrintNumber?: number | null }} variation
 */
export function findParallelDefinition(parallelData, variation) {
    if (!parallelData?.length || !variation?.cardParallelName) return null;
    const nameNorm = normalizeForCompare(variation.cardParallelName);
    const candidates = parallelData.filter((p) => {
        const n = typeof p === 'string' ? p : p?.name ?? p?.text ?? '';
        return normalizeForCompare(n) === nameNorm;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) {
        const only = candidates[0];
        return typeof only === 'object' && only != null ? only : null;
    }

    const supply = variation.cardSupply != null ? Number(variation.cardSupply) : null;
    if (supply != null && !Number.isNaN(supply)) {
        const byRun = candidates.find((c) => typeof c === 'object' && Number(c?.limitedTo) === supply);
        if (byRun) return byRun;
    }
    const unnumbered = candidates.find(
        (c) => typeof c === 'object' && (c?.limitedTo == null || c?.limitedTo === '')
    );
    if (unnumbered) return unnumbered;
    const firstObj = candidates.find((c) => typeof c === 'object' && c != null);
    return firstObj ?? null;
}

/** @returns {Array<[string, string | number]>} */
export function getDefinedOddsEntries(odds) {
    if (!odds || typeof odds !== 'object' || Array.isArray(odds)) return [];
    return Object.entries(odds).filter(
        ([, v]) => v != null && (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean')
    );
}

export function formatOddsForDisplay(value) {
    if (value == null) return '';
    if (typeof value === 'number' && value > 0) return `1:${value}`;
    return String(value);
}

/** All-caps label for parallel pills in the queue (e.g. "Dark Blue Bordered" → "DARK BLUE BORDERED"). */
export function queueParallelAttributeText(collectedParallel) {
    const raw = collectedParallel.cardSupply
        ? `${collectedParallel.cardParallelName} (${collectedParallel.cardPrintNumber}/${collectedParallel.cardSupply})`
        : String(collectedParallel.cardParallelName ?? '');
    return raw.toUpperCase();
}
